/**
 * Notification service — wraps the notification endpoints.
 * All calls use the shared `api` instance (Bearer token auto-attached).
 */
import api from './api'
import type { ApiResponse, PaginatedResponse } from '../types'

/** Backend NotificationType enum (entity Notification.NotificationType). */
export type NotificationType =
  | 'FRIEND_REQUEST' | 'POST_LIKE' | 'COMMENT' | 'FOLLOW'
  | 'MENTION' | 'MESSAGE' | 'SYSTEM' | 'REPORT'

export interface AppNotification {
  id: number
  type: string
  title: string
  message: string
  referenceId: number | null
  referenceType: string | null
  isRead: boolean
  createdAt: string
}

const unwrap = <T>(r: any): T => r.data.data as T

export const notificationService = {
  getNotifications: (page = 0, size = 50): Promise<PaginatedResponse<AppNotification>> =>
    api
      .get<ApiResponse<PaginatedResponse<AppNotification>>>(`/notifications?page=${page}&size=${size}`)
      .then(unwrap<PaginatedResponse<AppNotification>>),

  getUnreadCount: (): Promise<number> =>
    api.get<ApiResponse<number>>('/notifications/unread-count').then(unwrap<number>),

  markAsRead: (id: number): Promise<void> =>
    api.put(`/notifications/${id}/read`).then(() => undefined),

  markAllAsRead: (): Promise<void> =>
    api.put('/notifications/read-all').then(() => undefined),

  deleteNotification: (id: number): Promise<void> =>
    api.delete(`/notifications/${id}`).then(() => undefined),

  deleteAllRead: (): Promise<void> =>
    api.delete('/notifications/read').then(() => undefined),
}

export default notificationService